import { NavbarMenuItem } from '@heroui/react';
import { NavLink } from 'react-router-dom';
import type { NavbarLinkProps } from '../models/navbar.model';

/**
 * Propiedades del componente NavbarMenuMobile
 *
 * @interface Props
 * @property {NavbarLinkProps} item - Datos del item de navegación
 * @property {() => void} onClick - Callback para cerrar el menú al hacer click
 */
interface Props {
  item: NavbarLinkProps;
  onClick: () => void;
}

/**
 * Item de navegación para el menú móvil desplegable
 * Se renderiza dentro del NavbarMenu cuando el usuario abre el menú hamburguesa
 */
const NavbarMenuMobile = ({ item, onClick }: Props) => {
  return (
    <NavbarMenuItem className="w-full flex flex-col gap-5">
      <NavLink
        to={item.path || '#'}
        onClick={onClick}
        className="isActive__item-link"
      >
        {item.label}
      </NavLink>
    </NavbarMenuItem>
  );
};
export default NavbarMenuMobile;
